import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import { cn } from '../../components/ui/Button';
import NotificationBell from '../../components/NotificationBell';
import supabase from '../../supabase/supabase';

const LOGO_URL = "https://res.cloudinary.com/dfg8nrgvf/image/upload/q_auto/f_auto/v1780696106/Remove_Background_wepspn.png";

export default function CustomerLayout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [checkingAuth, setCheckingAuth] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) {
        navigate('/login');
      } else {
        setCheckingAuth(false);
      }
    };
    checkAuth();

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      if (!session) navigate('/login');
    });

    return () => subscription.unsubscribe();
  }, [navigate]);

  const navItems = [
    { icon: 'Home', label: 'Home', path: '/app' },
    { icon: 'Calendar', label: 'Bookings', path: '/app/bookings' },
    { icon: 'Heart', label: 'Favorites', path: '/app/favorites' },
    { icon: 'User', label: 'Profile', path: '/app/profile' }
  ];

  if (checkingAuth) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="w-12 h-12 border-4 border-brand-primary border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 flex justify-center items-center">
      <div className="w-full max-w-md bg-white h-[100dvh] sm:h-[800px] relative shadow-2xl sm:rounded-[2.5rem] sm:border-[8px] sm:border-gray-900 overflow-hidden flex flex-col">
        
        {/* Mobile Header */}
        <header className="px-6 pt-6 pb-4 flex justify-between items-center bg-white sticky top-0 z-50 border-b border-gray-100">
          <div className="flex items-center gap-2 cursor-pointer" onClick={() => navigate('/app')}>
            <img src={LOGO_URL} alt="BookOTG" className="h-16 w-auto object-contain" />
          </div>
          <NotificationBell light={true} />
        </header>

        {/* Main Content */}
        <main className="flex-1 overflow-y-auto hide-scrollbar pb-20 relative">
          {children}
        </main>

        {/* Bottom Nav */}
        <nav className="absolute bottom-0 left-0 w-full bg-white border-t border-gray-100 px-6 py-3 flex justify-between items-center pb-safe z-20">
          {navItems.map((item) => {
            const isActive = item.path === '/app' 
              ? location.pathname === '/app' || location.pathname === '/app/book' 
              : location.pathname.startsWith(item.path);
              
            return (
              <button 
                key={item.path}
                onClick={() => navigate(item.path)}
                className={cn(
                  "flex flex-col items-center gap-1 transition-all active:scale-95 px-2 py-1",
                  isActive ? "text-brand-primary" : "text-gray-400 hover:text-gray-600"
                )}
              >
                <SafeIcon name={item.icon} className={cn("text-[22px]", isActive ? "fill-brand-primary text-brand-primary" : "text-gray-400")} />
                <span className={cn("text-[10px] font-medium", isActive && "font-bold text-brand-primary")}>
                  {item.label}
                </span>
              </button>
            );
          })}
        </nav>
      </div>
    </div>
  );
}